import { gql } from 'apollo-angular';

const GET_OFFER_MIX_RESULT = gql`
  query GetOfferMixResult($id: Long!) {
    offerMixResult(id: $id) {
      buyer {
        id
        name
      }
      createdBy
      createdDate
      currentSellerSpendLevel {
        absoluteDollars
        absoluteUnits
        dollarMarketShare
        spendLevelType
        unitMarketShare
      }
      id
      lastModifiedBy
      lastModifiedDate
      offer {
        id
        name
      }
      seller {
        id
        name
      }
      tierType
      tiers {
        tier {
          id
          name
          description
          tierType
          order
          spendLevelType
          spendMarketShare
          spendVolume
          unitMarketShare
          unitVolume
        }
      }
    }
  }
`;

export default GET_OFFER_MIX_RESULT;
